import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useSpotHasChangedModal() {
  const { userRef } = useStorage();
  const storage = useStorage();
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });
  const { t } = useTranslation();

  function didOpen() {
    analyticsPageView('Spot Changing');
  }

  async function fire({ orders, oldSpot, newSpot }) {
    const selfOrders = orders?.find(
      (o) => o.bill?.customer?.id === userRef.current?.id
    );

    if (oldSpot == null) {
      return;
    }

    const name = userRef.current?.name ?? t('hello');
    let text = null;
    let icon = null;

    if (oldSpot != null && !_.isEmpty(selfOrders)) {
      icon = 'success';
      text = `${name}, ${t(
        `spot.change.success${newSpot?.prepaid ? '.prepaid' : ''}`
      )}`;
    }

    if (text == null) {
      return;
    }

    await swal.fire({
      title: newSpot.name,
      icon,
      text,
      didOpen,
      showDenyButton: false,
      showCancelButton: false,
      confirmButtonText: t('ok'),
    });
  }

  return fire;
}

export { useSpotHasChangedModal };
